import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dataForm",
  style: {"min-width":"1000px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_AccountPreview = _resolveComponent("AccountPreview")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_ctx.detail)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "form-title mb-10" }, [
          _createElementVNode("span", { class: "label blue" }, "业"),
          _createElementVNode("span", { class: "left" }, "业务信息")
        ], -1)),
        _createVNode(_component_el_descriptions, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, { label: "编号：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.business.no), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "名称：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.business.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "品牌：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.business.brand), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "数量：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.business.amount), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "税率：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.business.orderTaxRate ? `${_ctx.detail.business.orderTaxRate}%` : '未订单'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "含税单价：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.business.orderFee ? _ctx.$currency(_ctx.detail.business.orderFee) : '未订单'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "未税单价：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.business.orderFee ? _ctx.$currency(_ctx.detail.business.orderFee / (1 + _ctx.detail.business.orderTaxRate / 100)) : '未订单'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "含税总价：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.business.orderFee ? _ctx.$currency((_ctx.detail.business.amount ?? 0) * (_ctx.detail.business.orderFee ?? 0)) : '未订单'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "未税总价：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.business.orderFee ? _ctx.$currency(_ctx.detail.business.orderFee / (1 + _ctx.detail.business.orderTaxRate / 100) * (_ctx.detail.business.amount ?? 0)) : '未订单'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "单位：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.business.unit), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "型号：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.business.model), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "序列号：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.business.serial), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "客户公司名称：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.customerCompany), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "外包公司：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.outsourceCompany), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "form-title mb-10 mt-30" }, [
          _createElementVNode("span", { class: "label yellow" }, "审"),
          _createElementVNode("span", { class: "left" }, "审批信息")
        ], -1)),
        _createVNode(_component_AccountPreview, {
          account: _ctx.detail.fee.account
        }, {
          content: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, { label: "总费用：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$currency(_ctx.detail.fee.fee)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "是否含税 ：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.fee.containsRate), 1)
              ]),
              _: 1
            }),
            (_ctx.detail.fee.containsRate === '是')
              ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                  key: 0,
                  label: "税率："
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail.fee.rate) + "%", 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_descriptions_item, { label: "申请时间：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.fee.createTime), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "申请次数：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.times), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "发票类型：" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detail.fee.invoiceType), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["account"]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "form-title mb-10 mt-30" }, [
          _createElementVNode("span", { class: "label green" }, "历"),
          _createElementVNode("span", { class: "left" }, "历史申请费用")
        ], -1)),
        _createVNode(_component_el_table, {
          data: _ctx.detail.history || [],
          border: "",
          fit: "",
          "row-key": "id",
          class: "fullWidth",
          "header-cell-style": { background: '#ddd', color: 'rgba(0,0,0,0.9)' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "fee",
              label: "总费用",
              align: "right"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_ctx.$currency(row.fee)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "containsRate",
              label: "是否含税"
            }),
            _createVNode(_component_el_table_column, {
              prop: "rate",
              label: "税率"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.rate) + "% ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "createTime",
              label: "申请时间",
              "min-width": "130"
            }),
            _createVNode(_component_el_table_column, {
              prop: "invoiceType",
              label: "发票类型"
            }),
            _createVNode(_component_el_table_column, {
              prop: "times",
              label: "申请次数"
            }),
            _createVNode(_component_el_table_column, {
              prop: "account.alias",
              label: "账号信息",
              "min-width": "150"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]))
    : _createCommentVNode("", true)
}